<script>
  /** @type {null|'top'|'right'|'bottom'|'right'}*/
  export let position = 'top'

  /** @type {string?} */
  export let text = null
</script>

{#if text || $$slots.text}
  <span class="tooltip">
    <slot />
    <span role="tooltip" class="content {position}">
      {#if $$slots.text}
        <slot name="text" />
      {:else}
        {text}
      {/if}
    </span>
  </span>
{:else}
  <slot />
{/if}

<style>
  .tooltip {
    /* Why not */
    display: flex;
    align-items: center;

    position: relative;
    z-index: 1;
  }

  .content {
    --pointer-height: 0.5rem;
    --pointer-width: 1rem;

    --bottom-tip: conic-gradient(
        from -45deg at bottom,
        rgba(0, 0, 0, 0),
        #000 1deg 85deg,
        rgba(0, 0, 0, 0) 86deg
      )
      bottom / var(--pointer-width) var(--pointer-height) no-repeat;
    --top-tip: conic-gradient(
        from 138deg at top,
        rgba(0, 0, 0, 0),
        #000 -1deg 85deg,
        rgba(0, 0, 0, 0) 86deg
      )
      top / var(--pointer-width) var(--pointer-height) no-repeat;
    --right-tip: conic-gradient(
        from -120deg at right,
        rgba(0, 0, 0, 0),
        #000 1deg 60deg,
        rgba(0, 0, 0, 0) 61deg
      )
      right / 50% 100% no-repeat;
    --left-tip: conic-gradient(
        from 60deg at left,
        rgba(0, 0, 0, 0),
        #000 1deg 60deg,
        rgba(0, 0, 0, 0) 61deg
      )
      left / 50% 100% no-repeat;

    inline-size: max-content;
    max-inline-size: 27ch;
    padding: 0.35rem 0.5rem;
    margin: 0;

    position: absolute;
    z-index: 1;

    opacity: 0;
    pointer-events: none;
    user-select: none;
    text-align: start;
    font-weight: normal;
    line-height: normal;
    font-family: var(--document-font-family);
    font-size: 0.8125rem;
    color: #fff;
    border-radius: var(--border-radius-xs);
    background: rgb(var(--rgb-gray));

    will-change: filter;
    transform: translateX(var(--x, 0)) translateY(var(--y, 0));
    transition:
      opacity 150ms var(--ease-in),
      transform 150ms var(--ease-in);
  }

  /* when those parent elements have focus, hover, etc */
  .tooltip:is(:hover, :focus-visible, :active) > .content {
    opacity: 1;
    transition-delay: 150ms;
    transition-timing-function: var(--ease-out);
  }

  /* prepend some prose for screen readers only */
  .content::before {
    content: '; Has tooltip: ';
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    width: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
  }

  /* tooltip shape is a pseudo element so we can cast a shadow */
  .content::after {
    content: '';
    background: rgb(var(--rgb-gray));
    position: absolute;
    z-index: -1;
    inset: 0;
    mask: var(--tip);
    border-radius: var(--border-radius-sm);
  }

  .content.top {
    --x: calc(50% * -1);
    inset-inline-start: 50%;
    inset-block-end: calc(100% + var(--pointer-height));
  }

  .content.top::after {
    --tip: var(--bottom-tip);
    inset-block-end: calc(var(--pointer-height) * -1);
    border-block-end: var(--pointer-height) solid transparent;
  }

  .content.bottom {
    --x: calc(50% * -1);
    inset-inline-start: 50%;
    inset-block-start: calc(100% + var(--pointer-height));
  }

  .content.bottom::after {
    --tip: var(--top-tip);
    inset-block-start: calc(var(--pointer-height) * -1);
    border-block-end: var(--pointer-height) solid transparent;
  }
</style>
